import { lazy } from "react";
import { createHashRouter as createRouter } from "react-router-dom";
// import Login from "../pages/login";
import Login from "../pages/login_page";
import recordingRouter from "./modules/recording_manage";
import MemberRouter from "./modules/user_manage";
import ConfirmLogin from "../pages/login_page/confirm_login";
import AthComponent from "../components/ath_component";
import ChooseCompany from "../pages/choose_company";
import HomeRouter from "./modules/home";
import NotFound from "../pages/not_found";
import Personal from "../pages/personal_page";
import NumberPoolRouter from "./modules/number_pool_manage";
import videoRouter from "./modules/video_manage";
import CallCardRouter from "./modules/call_card";
import CallOutRouter from "./modules/call_out";
import ScriptRouter from "./modules/script_manage";

const isAth = (path: string) => {
  return window.location.href.includes(path);
};
export const COMMON_ROUTE = [
  // {
  //     path:'/',
  //     element:<Navigate to="/confirmLogin"/>
  // },
  {
    path: "/",
    element: <ConfirmLogin />,
  },
  {
    path: "/confirmLogin",
    element: <ConfirmLogin />,
  },
  {
    path: "/personal",
    element: <Personal />,
  },
  {
    path: "/chooseCompany",
    element: <ChooseCompany />,
  },
  {
    path: "/login",
    element: isAth("/login") ? AthComponent(Login, "") : <Login />,
  },
  // {
  //   path:'/404',
  //   element:<NotFound/>
  // }
];


/* 权限路由 */
export const AUTH_ROURE = [...MemberRouter, ...NumberPoolRouter,...videoRouter,...recordingRouter,...CallCardRouter,...CallOutRouter,...ScriptRouter,];

/* 异常路由 */
export const ERROR_ROUTE = [
  {
    path: "*",
    // element: lazy(() => import('../pages/404'))
    element: <NotFound />,
  },
];

const routes: any = [
  ...COMMON_ROUTE,
  ...AUTH_ROURE,
  ...ERROR_ROUTE,
  ...HomeRouter,
  ...ScriptRouter,
];

const router = createRouter(routes);

export default { router, AUTH_ROURE };
